module.exports = __webpack_public_path__ + "static/media/icon-alert-big.4e8668c1.svg";